import { Flex } from '@blockanalitica/ui';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import KpiMultiCard, { KpiCardProps } from './KpiMultiCard';

const KpiLabel = styled.div`
  font-size: ${(props) => props.theme.sizes['0']};
  font-weight: 500;

  ${(props) => css`
    font-size: ${props.theme.sizes['0']};
    color: ${props.theme.colors.muted};
  `}
`;

const KpiValue = styled.div`
  ${(props) => css`
    font-size: ${props.theme.sizes['1']};
    color: ${props.theme.colors.text};
  `}
`;

interface MultipleKpiCardProps extends Omit<KpiCardProps, 'footer'> {
  footer?: { title: ReactNode; value: ReactNode }[];
}

export default function MultipleKpiCard({
  footer,
  ...rest
}: MultipleKpiCardProps) {
  let footerContent = null;
  if (footer) {
    footerContent = (
      <Flex justifyContent="space-between" width="100%" fontSize="0" gap="xs">
        {footer.map((foot, idx) => (
          <Flex
            key={
              typeof foot.title === 'string' || typeof foot.title === 'number'
                ? foot.title
                : idx
            }
            flexDirection="column"
            gap="2xs"
            flexBasis="100%">
            <KpiLabel>{foot.title}</KpiLabel>
            <KpiValue>{foot.value}</KpiValue>
          </Flex>
        ))}
      </Flex>
    );
  }

  return <KpiMultiCard footer={footerContent} {...rest} />;
}
